export default __webpack_public_path__ + "static/certificate-pr-vertical-f192f937982afc4dcaac149616fb6c82.jpg";